// src/utils/fontawesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faTimes,
  faCrown,
  faVideo,
  faPlay,
  faSpinner,
  faImage,
  faMagic,
  faImages,
  faArrowLeft,
  faArrowRight,
  faUnlock,
  faPlus,
  faTrash,
  faTrashAlt, // Añadido
  faEdit,
  faUser,
  faCog,
  faCoffee,
  faSignOutAlt,
  faSignInAlt,
  faHome,
  faSearch,
  faHeart,
  faComment,
  faEye,
  faEyeSlash,
  faLock,
  faLockOpen,
  faUpload,
  faCloudUploadAlt,
  faDownload,
  faShare,
  faSave,
  faExclamationTriangle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  faExclamationCircle,
  faBars,
  faTh,
  faThList,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAngleDown,
  faEllipsisV,
  faEllipsisH,
  faCopy,
  faPaste,
  faCut,
  faUndo,
  faRedo,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faLink,
  faUnlink,
  faListUl,
  faListOl,
  faIndent,
  faOutdent,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faCamera,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileArchive,
  faFileCode,
  faFileAlt,
  faFile,
  faCalendarAlt, // Añadido
  faPaperPlane, // Añadido
  faPlayCircle, // Añadido
  faCalendar, // Añadido por si acaso
} from '@fortawesome/free-solid-svg-icons';

// Añadir los íconos que necesitas a la biblioteca
library.add(
  faCheck,
  faCrown,
  faMagic,
  faTimes,
  faCoffee,
  faVideo,
  faPlay,
  faSpinner,
  faImage,
  faUnlock,
  faImages,
  faArrowLeft,
  faArrowRight,
  faPlus,
  faTrash,
  faTrashAlt, // Añadido
  faEdit,
  faUser,
  faCog,
  faSignOutAlt,
  faSignInAlt,
  faHome,
  faSearch,
  faHeart,
  faComment,
  faEye,
  faEyeSlash,
  faLock,
  faLockOpen,
  faUpload,
  faCloudUploadAlt,
  faDownload,
  faShare,
  faSave,
  faExclamationTriangle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  faExclamationCircle,
  faBars,
  faTh,
  faThList,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAngleDown,
  faEllipsisV,
  faEllipsisH,
  faCopy,
  faPaste,
  faCut,
  faUndo,
  faRedo,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faLink,
  faUnlink,
  faListUl,
  faListOl,
  faIndent,
  faOutdent,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faCamera,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileArchive,
  faFileCode,
  faFileAlt,
  faFile,
  faCalendarAlt, // Añadido
  faPaperPlane, // Añadido
  faPlayCircle, // Añadido
  faCalendar // Añadido por si acaso
);
